import listActions from 'src/modules/nivelPuesto/list/nivelPuestoListActions';
import NivelPuestoService from 'src/modules/nivelPuesto/nivelPuestoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'NIVELPUESTO_DESTROY';

const nivelPuestoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPuestoDestroyActions.DESTROY_STARTED,
      });

      await NivelPuestoService.destroyAll([id]);

      dispatch({
        type: nivelPuestoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.nivelPuesto.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/nivel-puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: nivelPuestoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPuestoDestroyActions.DESTROY_ALL_STARTED,
      });

      await NivelPuestoService.destroyAll(ids);

      dispatch({
        type: nivelPuestoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.nivelPuesto.destroyAll.success'),
      );

      getHistory().push('/nivel-puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: nivelPuestoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default nivelPuestoDestroyActions;
